import { render } from "./informations.vue?vue&type=template&id=6976b402"
import script from "./informations.js?vue&type=script&lang=js&external"
export * from "./informations.js?vue&type=script&lang=js&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__